import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('es');

@Pipe({name: 'customDate'})
export class CustomDatePipe implements PipeTransform {
  transform(value: any): string {
    if (moment(value).isValid()) {
      const baseDate = moment(value).fromNow();
      return baseDate;
    }
    return null;
  }
}
